export default __webpack_public_path__ + "static/media/Bookmark.e5da001d.svg";